import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface SidePanelManagerSectionProps {
  title?: ReactNode;
  link?: ReactNode;
}

/*
 * Style.
 */

const StyledSectionDiv = styled.div`
  margin: 16px;

  & + & {
    margin-top: 24px;
  }

  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-row-gap: 16px;
`;

const StyledHeaderDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`;

const StyledTitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.medium};
`;

/*
 * Component.
 */

export const SidePanelManagerSection: FC<SidePanelManagerSectionProps> = (props) => (
  <StyledSectionDiv>
    {maybeRenderHeader(props)}
    {props.children}
  </StyledSectionDiv>
);

function maybeRenderHeader(props: SidePanelManagerSectionProps) {
  if (!props.title) {
    return null;
  }

  return (
    <StyledHeaderDiv>
      <StyledTitleDiv>{props.title}</StyledTitleDiv>
      <div>{props.link}</div>
    </StyledHeaderDiv>
  );
}
